import star from "../assets/img/star.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    return (
        <section className="skill" id="skills">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="skill-bx wow zoomIn">
                            <h2>Skills</h2>
                            <p>My skills are a combination of technical and soft skills which I have developed over the years. I am constantly improving and also learning new skills to help me in my career path.</p>
                            <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                                <div className="item">
                                    <img src={star} alt="Web Development skill icon" />
                                    <h5>Web Development</h5>
                                </div>
                                <div className="item">
                                    <img src={star} alt="Data Analytics skill icon" />
                                    <h5>Data Analytics</h5>
                                </div>
                                <div className="item">
                                    <img src={star} alt="Leadership skill icon" />
                                    <h5>Leadership</h5>
                                </div>
                                <div className="item">
                                    <img src={star} alt="Problem Solving skill icon" />
                                    <h5>Problem Solving</h5>
                                </div>
                                <div className="item">
                                    <img src={star} alt="Time Management skill icon" />
                                    <h5>Time Management</h5>
                                </div>
                                <div className="item">
                                    <img src={star} alt="Networking skill icon" />
                                    <h5>Networking</h5>
                                </div>
                                <div className="item">
                                    <img src={star} alt="Technical Writing skill icon" />
                                    <h5>Technical Writing</h5>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
            <img className="background-image-left" src={colorSharp} alt="Background decoration" />
        </section>
    )
}